import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import moment from "moment";

import {TeamAPI, InviteTeamAPI, DeleteTeamAPI} from "../../API/Sales/TeamAPI";
import Sidebar from "./Common/Sidebar";
import Header from "./Common/Header";
import InvitationModal from "./InvitationModal";
import Loader from "../Loader";
import Paginate from "../../utils/Pagination";
import DeleteConfirmPopup from "../../utils/DeleteConfirmPopup";
import { ToastContainer } from "react-toastify";


const Teams = () =>{

    const [teams, setTeams] = useState([]);
    const [loading, setLoading] = useState(false);
    const [currentPage, setCurrentPage] = useState(1);
    const [pagecount, setPageCount] = useState(0);
    const [showPopup, setShowPopup] = useState(false);
    const [email, setEmail] = useState("");
    const [showdeletepopup, setShowDeletePopup] = useState(false);
    const [headertext, setHeaderText] = useState("Delete this caller?");
    const [deletepopupcontent, setDeletePopupContent] = useState("Are you sure to delete this team lead?");
    const [deleteteamid, setDeleteTeamID] = useState(null);
    const [isteamdelete, setIsTeamDelete] = useState(false);
    const [isteamadd, setIsTeamAdd] = useState(false);
    const [showinvitespinner, setShowInviteSpinner] = useState(false);
    const [showdeletespinner, setShowDeleteSpinner] = useState(false);
    
    const perpagedata = 15;


    useEffect(() => {

        TeamAPI(setTeams, setLoading, currentPage, perpagedata, setPageCount);

        //console.log('>>>>'+usersList);

    }, [currentPage, isteamdelete, isteamadd]);

    const handlePageClick = (data) =>{
        setCurrentPage(data.selected + 1);

    }

    const handlePopToggle = () =>{
        setShowPopup(!showPopup);
    }

    const handlePopupClose = () =>{
        setShowPopup(false);
    }

    const handleInputEmail = (event) =>{

        setEmail(event.target.value);
    }

    const handleTeamInvite = () =>{

        console.log('Submit email===' + email);

        const params = {
                        "email": email
                    }

        InviteTeamAPI(params, setIsTeamAdd, setShowPopup, setShowInviteSpinner);
    }

    const handleButtonCancel = () =>{
        setShowDeletePopup(false);
    }
    
    const handleButtonDelete = (e) =>{
        //event.preventDefault();

        console.log('deleted caller id===='+deleteteamid);

        /*const params = {
                        "callerid": deletecallerid
                    };*/
        if(deleteteamid > 0)
        {
            DeleteTeamAPI(deleteteamid, setIsTeamDelete, setShowDeletePopup, setShowDeleteSpinner);
        }
        
    }

    const handleDeleteTeamPopup = (teamid) =>{
        setShowDeletePopup(!showdeletepopup);

        setDeleteTeamID(teamid);
    }


    return(
    <div className="main-wrapper">
        <Loader />

        <Header />

        <Sidebar />

        <div className="page-wrapper">
            <div className="content">

                <div className="row">
                    <div className="col-md-12">

                        <div className="page-header">
                            <div className="row align-items-center">
                                <div className="col-lg-10 col-sm-12">
                                    <h4 className="page-title">Teams</h4>
                                </div>
                                <div className="col-lg-2 col-sm-12 d-flex justify-content-end p-0">
                                    <button type="button" className="btn btn-primary" onClick={handlePopToggle}>
                                        <i className="ti ti-square-rounded-plus me-2"></i>Invite
                                    </button>
                                </div>
                            </div>
                        </div>

                        <div className="card">
                            <div className="card-body">
                                <div className="table-responsive custom-table">
                                    <table className="table" id="faqlist">
                                        <thead className="thead-light">
                                            <tr>                                                
                                                <th style={{ width: "20%" }}>Name</th>
                                                <th style={{ width: "20%" }}>Email</th>
                                                <th style={{ width: "15%" }}>Last Seen</th>
                                                <th style={{ width: "15%" }}>Last Login IP</th>
                                                <th style={{ width: "10%" }}>Status</th>
                                                <th style={{ width: "10%" }}>Created On</th>
                                                <th style={{ width: "10%" }}>Action</th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                    
                                        {loading ?
                                            <tr>
                                                <td colSpan="7">
                                                    <Loader />
                                                </td>
                                            </tr>
                                        :
                                            (teams && teams.length > 0  ? 
                                                ( teams.map(team => 
                                                    (
                                            
                                                        <tr key={team.id}>
                                                            <td>{team.name ? team.name : "-"}</td>
                                                            <td>{team.email}</td>
                                                            <td>
                                                                { team.last_login_date ?
                                                                    (moment(team.last_login_date).format('DD-MM-YYYY'))
                                                                :
                                                                    <p>-</p>
                                                                }
                                                            </td>
                                                            <td>
                                                                { team.last_login_ip ?
                                                                    (team.last_login_ip)
                                                                :
                                                                    <p>-</p>
                                                                }
                                                            </td>
                                                            <td>
                                                                { team.is_invitation_sent == 1 ?
                                                                    <span class="badge badge-pill badge-status bg-warning">Pending</span>
                                                                :
                                                                    (team.is_invitation_sent == 2 ?
                                                                        <span class="badge badge-pill badge-status bg-success">Active</span>
                                                                    :
                                                                        <span class="badge badge-pill badge-status bg-danger">Inactive</span>
                                                                    )
                                                                }
                                                            </td>
                                                            <td>{ moment(team.created_at).format('DD-MM-YYYY') }</td>
                                                            <td>  
                                                                <button type="button" class="btn btn-danger btn-sm" onClick={()=> handleDeleteTeamPopup(team.id)}>
                                                                    <i className="ti ti-trash"></i> Delete
                                                                </button>	
                                                                									
                                                            </td>
                                                        </tr>
                                                    )
                                                ))
                                            
                                            :
                                        
                                                <tr>
                                                    <td colSpan="7">
                                                        <p>No record found...</p>
                                                    </td>
                                                </tr>
                                            )
                                        }
                                    
                                        </tbody>
                                    </table>
                                    
                                </div>
                                

                            </div>
                        </div>
                        
                        {pagecount > 1 ?
                        <div className="row pagination-section">
                            <nav>
                                <Paginate initialPage={perpagedata} pageCount={pagecount} onPageChange={handlePageClick} />
                            </nav>
                        </div>
                        :
                            <></>
                        }

                    </div>
                </div>
                
                <InvitationModal toggleShow={showPopup} btnClose={handlePopupClose} btnTeamInvite={handleTeamInvite} inputEmail={handleInputEmail} txtemail={email} btninvitespin={showinvitespinner} />

                <DeleteConfirmPopup toggleDeleteShow={showdeletepopup} btnCancel={handleButtonCancel} btnDelete={handleButtonDelete} txtModalHeader={headertext} txtModalContent={deletepopupcontent} btndeletespin={showdeletespinner} />
                
                <ToastContainer />
            </div>
        </div>

    </div>
    )
}

export default Teams;